import z from 'zod';
const reconstructedDocumentEntrySchema = z.looseObject({
    reconstructedDocumentId: z.string(),
    /** The effective class: the user's entity override when set, else the model class (DR-6377). */
    classification: z.string(),
    /** Confidence on a 0..1 scale; exactly 1 when the class is a user override (DR-6377). */
    classificationCertainty: z.number(),
    startPageIndex: z.number(),
    endPageIndex: z.number(),
    pageIds: z.array(z.string()),
    reconstructedPdfPath: z.string(),
    suggestedFilename: z.string(),
});
export const documentUpdatedWebhookSchema = z.looseObject({
    type: z.literal('document-updated'),
    projectId: z.string(),
    documentId: z.string(),
    correlationId: z.string().optional(),
    classification: z.array(z.tuple([z.string(), z.number()])),
    userSuggestedCategory: z.string().nullable(),
    reconstructedDocuments: z.array(reconstructedDocumentEntrySchema),
    bytes: z.number(),
});
//# sourceMappingURL=document-updated.webhook.js.map